import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=f2434206&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"
import style0 from "./Live.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports